<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Turnaround Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="title">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit turnaround'">
      <template #gated-content>
        <turnaround-form :turnaround="turnaround" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TurnaroundForm from "@/components/lab/turnaround/TurnaroundForm";
import { getModel } from "@/shared/fetch-utils";
import { notificationOptions } from "@/shared/toast-notification-options";
import { turnaroundNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const TurnaroundRepository = LabRepositoryFactory.get("turnaround");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "TurnaroundEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TurnaroundForm,
  },
  data() {
    return {
      loading: true,
      laboratory_id: this.$store.getters.getLaboratoryContext.id || null,
      turnaround_id: this.$route.params.turnaround_id || null,
      turnaround: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/turnarounds",
            title: "Turnaround list",
          },
          {
            icon: "fa-eye",
            linkto: `/turnarounds/${this.turnaround_id}`,
            title: "View turnaround",
            variant: "info",
          },
        ],
      };
    },
    sample_type() {
      return this.turnaround ? this.turnaround.getSampleType() : null;
    },
    title() {
      return `Update ${
        this.sample_type ? this.sample_type.name : "Sample Type not specified"
      }: ${this.turnaround && this.turnaround.name}`;
    },
  },
  methods: {
    async submit(form_data) {
      try {
        await TurnaroundRepository.update(this.turnaround_id, form_data);

        this.editSuccess();
        this.$router.push(`/turnarounds/${this.turnaround_id}`);
      } catch ({ response }) {
        this.editFail();
      }
    },
  },
  async created() {
    this.loading = true;

    this.turnaround = await getModel({
      model_type: "turnaround",
      id: this.turnaround_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: turnaroundNotifications,
};
</script>
